export default {
  /* Router */

  LOCATION_CHANGE_HANDLE: 'LOCATION_CHANGE_HANDLE',
  LOCATION_CHANGE_HANDLE__BOARD_FETCH: 'LOCATION_CHANGE_HANDLE__BOARD_FETCH',

  /* Socket */

  SOCKET_DISCONNECT_HANDLE: 'SOCKET_DISCONNECT_HANDLE',
  SOCKET_RECONNECT_HANDLE: 'SOCKET_RECONNECT_HANDLE',
  SOCKET_RECONNECT_HANDLE__CORE_FETCH: 'SOCKET_RECONNECT_HANDLE__CORE_FETCH',

  /* Login */

  LOGIN_INITIALIZE: 'LOGIN_INITIALIZE',
  AUTHENTICATE: 'AUTHENTICATE',
  AUTHENTICATE__SUCCESS: 'AUTHENTICATE__SUCCESS',
  AUTHENTICATE__FAILURE: 'AUTHENTICATE__FAILURE',
  USING_OIDC_AUTHENTICATE: 'USING_OIDC_AUTHENTICATE',
  USING_OIDC_AUTHENTICATE__SUCCESS: 'USING_OIDC_AUTHENTICATE__SUCCESS',
  USING_OIDC_AUTHENTICATE__FAILURE: 'USING_OIDC_AUTHENTICATE__FAILURE',
  AUTHENTICATE_ERROR_CLEAR: 'AUTHENTICATE_ERROR_CLEAR',

  /* Core */

  CORE_INITIALIZE: 'CORE_INITIALIZE',
  CORE_INITIALIZE__CONFIG_FETCH: 'CORE_INITIALIZE__CONFIG_FETCH',
  LOGOUT: 'LOGOUT',
  LOGOUT__ACCESS_TOKEN_INVALIDATE: 'LOGOUT__ACCESS_TOKEN_INVALIDATE',

  /* Modals */

  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',

  /* Users */

  USER_CREATE: 'USER_CREATE',
  USER_CREATE__SUCCESS: 'USER_CREATE__SUCCESS',
  USER_CREATE__FAILURE: 'USER_CREATE__FAILURE',
  USER_CREATE_HANDLE: 'USER_CREATE_HANDLE',
  USER_CREATE_ERROR_CLEAR: 'USER_CREATE_ERROR_CLEAR',
  USER_UPDATE: 'USER_UPDATE',
  USER_UPDATE__SUCCESS: 'USER_UPDATE__SUCCESS',
  USER_UPDATE__FAILURE: 'USER_UPDATE__FAILURE',
  USER_UPDATE_HANDLE: 'USER_UPDATE_HANDLE',
  USER_EMAIL_UPDATE: 'USER_EMAIL_UPDATE',
  USER_EMAIL_UPDATE__SUCCESS: 'USER_EMAIL_UPDATE__SUCCESS',
  USER_EMAIL_UPDATE__FAILURE: 'USER_EMAIL_UPDATE__FAILURE',
  USER_EMAIL_UPDATE_ERROR_CLEAR: 'USER_EMAIL_UPDATE_ERROR_CLEAR',
  USER_PASSWORD_UPDATE: 'USER_PASSWORD_UPDATE',
  USER_PASSWORD_UPDATE__SUCCESS: 'USER_PASSWORD_UPDATE__SUCCESS',
  USER_PASSWORD_UPDATE__FAILURE: 'USER_PASSWORD_UPDATE__FAILURE',
  USER_PASSWORD_UPDATE_ERROR_CLEAR: 'USER_PASSWORD_UPDATE_ERROR_CLEAR',
  USER_USERNAME_UPDATE: 'USER_USERNAME_UPDATE',
  USER_USERNAME_UPDATE__SUCCESS: 'USER_USERNAME_UPDATE__SUCCESS',
  USER_USERNAME_UPDATE__FAILURE: 'USER_USERNAME_UPDATE__FAILURE',
  USER_USERNAME_UPDATE_ERROR_CLEAR: 'USER_USERNAME_UPDATE_ERROR_CLEAR',
  USER_AVATAR_UPDATE: 'USER_AVATAR_UPDATE',
  USER_AVATAR_UPDATE__SUCCESS: 'USER_AVATAR_UPDATE__SUCCESS',
  USER_AVATAR_UPDATE__FAILURE: 'USER_AVATAR_UPDATE__FAILURE',
  USER_DELETE: 'USER_DELETE',
  USER_DELETE__SUCCESS: 'USER_DELETE__SUCCESS',
  USER_DELETE__FAILURE: 'USER_DELETE__FAILURE',
  USER_DELETE_HANDLE: 'USER_DELETE_HANDLE',
  USER_TO_CARD_ADD: 'USER_TO_CARD_ADD',
  USER_TO_CARD_ADD__SUCCESS: 'USER_TO_CARD_ADD__SUCCESS',
  USER_TO_CARD_ADD__FAILURE: 'USER_TO_CARD_ADD__FAILURE',
  USER_TO_CARD_ADD_HANDLE: 'USER_TO_CARD_ADD_HANDLE',
  USER_FROM_CARD_REMOVE: 'USER_FROM_CARD_REMOVE',
  USER_FROM_CARD_REMOVE__SUCCESS: 'USER_FROM_CARD_REMOVE__SUCCESS',
  USER_FROM_CARD_REMOVE__FAILURE: 'USER_FROM_CARD_REMOVE__FAILURE',
  USER_FROM_CARD_REMOVE_HANDLE: 'USER_FROM_CARD_REMOVE_HANDLE',
  USER_TO_BOARD_FILTER_ADD: 'USER_TO_BOARD_FILTER_ADD',
  USER_FROM_BOARD_FILTER_REMOVE: 'USER_FROM_BOARD_FILTER_REMOVE',

  /* Projects */

  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_CREATE__SUCCESS: 'PROJECT_CREATE__SUCCESS',
  PROJECT_CREATE__FAILURE: 'PROJECT_CREATE__FAILURE',
  PROJECT_CREATE_HANDLE: 'PROJECT_CREATE_HANDLE',
  PROJECT_UPDATE: 'PROJECT_UPDATE',
  PROJECT_UPDATE__SUCCESS: 'PROJECT_UPDATE__SUCCESS',
  PROJECT_UPDATE__FAILURE: 'PROJECT_UPDATE__FAILURE',
  PROJECT_UPDATE_HANDLE: 'PROJECT_UPDATE_HANDLE',
  PROJECT_BACKGROUND_IMAGE_UPDATE: 'PROJECT_BACKGROUND_IMAGE_UPDATE',
  PROJECT_BACKGROUND_IMAGE_UPDATE__SUCCESS: 'PROJECT_BACKGROUND_IMAGE_UPDATE__SUCCESS',
  PROJECT_BACKGROUND_IMAGE_UPDATE__FAILURE: 'PROJECT_BACKGROUND_IMAGE_UPDATE__FAILURE',
  PROJECT_DELETE: 'PROJECT_DELETE',
  PROJECT_DELETE__SUCCESS: 'PROJECT_DELETE__SUCCESS',
  PROJECT_DELETE__FAILURE: 'PROJECT_DELETE__FAILURE',
  PROJECT_DELETE_HANDLE: 'PROJECT_DELETE_HANDLE',

  /* Project managers */

  PROJECT_MANAGER_CREATE: 'PROJECT_MANAGER_CREATE',
  PROJECT_MANAGER_CREATE__SUCCESS: 'PROJECT_MANAGER_CREATE__SUCCESS',
  PROJECT_MANAGER_CREATE__FAILURE: 'PROJECT_MANAGER_CREATE__FAILURE',
  PROJECT_MANAGER_CREATE_HANDLE: 'PROJECT_MANAGER_CREATE_HANDLE',
  PROJECT_MANAGER_CREATE_HANDLE__PROJECT_FETCH: 'PROJECT_MANAGER_CREATE_HANDLE__PROJECT_FETCH',
  PROJECT_MANAGER_DELETE: 'PROJECT_MANAGER_DELETE',
  PROJECT_MANAGER_DELETE__SUCCESS: 'PROJECT_MANAGER_DELETE__SUCCESS',
  PROJECT_MANAGER_DELETE__FAILURE: 'PROJECT_MANAGER_DELETE__FAILURE',
  PROJECT_MANAGER_DELETE_HANDLE: 'PROJECT_MANAGER_DELETE_HANDLE',

  /* Boards */

  BOARD_CREATE: 'BOARD_CREATE',
  BOARD_CREATE__SUCCESS: 'BOARD_CREATE__SUCCESS',
  BOARD_CREATE__FAILURE: 'BOARD_CREATE__FAILURE',
  BOARD_CREATE_HANDLE: 'BOARD_CREATE_HANDLE',
  BOARD_FETCH: 'BOARD_FETCH',
  BOARD_FETCH__SUCCESS: 'BOARD_FETCH__SUCCESS',
  BOARD_FETCH__FAILURE: 'BOARD_FETCH__FAILURE',
  BOARD_UPDATE: 'BOARD_UPDATE',
  BOARD_UPDATE__SUCCESS: 'BOARD_UPDATE__SUCCESS',
  BOARD_UPDATE__FAILURE: 'BOARD_UPDATE__FAILURE',
  BOARD_UPDATE_HANDLE: 'BOARD_UPDATE_HANDLE',
  BOARD_DELETE: 'BOARD_DELETE',
  BOARD_DELETE__SUCCESS: 'BOARD_DELETE__SUCCESS',
  BOARD_DELETE__FAILURE: 'BOARD_DELETE__FAILURE',
  BOARD_DELETE_HANDLE: 'BOARD_DELETE_HANDLE',
  BOARD_ARCHIVE: 'BOARD_ARCHIVE',
  BOARD_ARCHIVE__SUCCESS: 'BOARD_ARCHIVE__SUCCESS',
  BOARD_ARCHIVE__FAILURE: 'BOARD_ARCHIVE__FAILURE',
  BOARD_ARCHIVE_HANDLE: 'BOARD_ARCHIVE_HANDLE',
  BOARD_RESTORE: 'BOARD_RESTORE',
  BOARD_RESTORE__SUCCESS: 'BOARD_RESTORE__SUCCESS',
  BOARD_RESTORE__FAILURE: 'BOARD_RESTORE__FAILURE',
  BOARD_RESTORE_HANDLE: 'BOARD_RESTORE_HANDLE',

  /* Board memberships */

  BOARD_MEMBERSHIP_CREATE: 'BOARD_MEMBERSHIP_CREATE',
  BOARD_MEMBERSHIP_CREATE__SUCCESS: 'BOARD_MEMBERSHIP_CREATE__SUCCESS',
  BOARD_MEMBERSHIP_CREATE__FAILURE: 'BOARD_MEMBERSHIP_CREATE__FAILURE',
  BOARD_MEMBERSHIP_CREATE_HANDLE: 'BOARD_MEMBERSHIP_CREATE_HANDLE',
  BOARD_MEMBERSHIP_CREATE_HANDLE__PROJECT_FETCH: 'BOARD_MEMBERSHIP_CREATE_HANDLE__PROJECT_FETCH',
  BOARD_MEMBERSHIP_UPDATE: 'BOARD_MEMBERSHIP_UPDATE',
  BOARD_MEMBERSHIP_UPDATE__SUCCESS: 'BOARD_MEMBERSHIP_UPDATE__SUCCESS',
  BOARD_MEMBERSHIP_UPDATE__FAILURE: 'BOARD_MEMBERSHIP_UPDATE__FAILURE',
  BOARD_MEMBERSHIP_UPDATE_HANDLE: 'BOARD_MEMBERSHIP_UPDATE_HANDLE',
  BOARD_MEMBERSHIP_DELETE: 'BOARD_MEMBERSHIP_DELETE',
  BOARD_MEMBERSHIP_DELETE__SUCCESS: 'BOARD_MEMBERSHIP_DELETE__SUCCESS',
  BOARD_MEMBERSHIP_DELETE__FAILURE: 'BOARD_MEMBERSHIP_DELETE__FAILURE',
  BOARD_MEMBERSHIP_DELETE_HANDLE: 'BOARD_MEMBERSHIP_DELETE_HANDLE',

  /* Labels */

  LABEL_CREATE: 'LABEL_CREATE',
  LABEL_CREATE__SUCCESS: 'LABEL_CREATE__SUCCESS',
  LABEL_CREATE__FAILURE: 'LABEL_CREATE__FAILURE',
  LABEL_CREATE_HANDLE: 'LABEL_CREATE_HANDLE',
  LABEL_UPDATE: 'LABEL_UPDATE',
  LABEL_UPDATE__SUCCESS: 'LABEL_UPDATE__SUCCESS',
  LABEL_UPDATE__FAILURE: 'LABEL_UPDATE__FAILURE',
  LABEL_UPDATE_HANDLE: 'LABEL_UPDATE_HANDLE',
  LABEL_DELETE: 'LABEL_DELETE',
  LABEL_DELETE__SUCCESS: 'LABEL_DELETE__SUCCESS',
  LABEL_DELETE__FAILURE: 'LABEL_DELETE__FAILURE',
  LABEL_DELETE_HANDLE: 'LABEL_DELETE_HANDLE',
  LABEL_TO_CARD_ADD: 'LABEL_TO_CARD_ADD',
  LABEL_TO_CARD_ADD__SUCCESS: 'LABEL_TO_CARD_ADD__SUCCESS',
  LABEL_TO_CARD_ADD__FAILURE: 'LABEL_TO_CARD_ADD__FAILURE',
  LABEL_TO_CARD_ADD_HANDLE: 'LABEL_TO_CARD_ADD_HANDLE',
  LABEL_FROM_CARD_REMOVE: 'LABEL_FROM_CARD_REMOVE',
  LABEL_FROM_CARD_REMOVE__SUCCESS: 'LABEL_FROM_CARD_REMOVE__SUCCESS',
  LABEL_FROM_CARD_REMOVE__FAILURE: 'LABEL_FROM_CARD_REMOVE__FAILURE',
  LABEL_FROM_CARD_REMOVE_HANDLE: 'LABEL_FROM_CARD_REMOVE_HANDLE',
  LABEL_TO_BOARD_FILTER_ADD: 'LABEL_TO_BOARD_FILTER_ADD',
  LABEL_FROM_BOARD_FILTER_REMOVE: 'LABEL_FROM_BOARD_FILTER_REMOVE',

  /* Lists */

  LIST_CREATE: 'LIST_CREATE',
  LIST_CREATE__SUCCESS: 'LIST_CREATE__SUCCESS',
  LIST_CREATE__FAILURE: 'LIST_CREATE__FAILURE',
  LIST_CREATE_HANDLE: 'LIST_CREATE_HANDLE',
  LIST_UPDATE: 'LIST_UPDATE',
  LIST_UPDATE__SUCCESS: 'LIST_UPDATE__SUCCESS',
  LIST_UPDATE__FAILURE: 'LIST_UPDATE__FAILURE',
  LIST_UPDATE_HANDLE: 'LIST_UPDATE_HANDLE',
  LIST_TRANSFER_PREPARE: 'LIST_TRANSFER_PREPARE',
  LIST_TRANSFER_PREPARE__SUCCESS: 'LIST_TRANSFER_PREPARE__SUCCESS',
  LIST_TRANSFER_PREPARE__FAILURE: 'LIST_TRANSFER_PREPARE__FAILURE',
  LIST_TRANSFER_PREPARE_CLEAR: 'LIST_TRANSFER_PREPARE_CLEAR',
  CARD_TRANSFER_PREPARE: 'CARD_TRANSFER_PREPARE',
  CARD_TRANSFER_PREPARE__SUCCESS: 'CARD_TRANSFER_PREPARE__SUCCESS',
  CARD_TRANSFER_PREPARE__FAILURE: 'CARD_TRANSFER_PREPARE__FAILURE',
  CARD_TRANSFER_PREPARE_CLEAR: 'CARD_TRANSFER_PREPARE_CLEAR',
  CARD_TRANSFER_POINT_SYSTEM_PROMPT: 'CARD_TRANSFER_POINT_SYSTEM_PROMPT',
  CARD_TRANSFER_POINT_SYSTEM_PROMPT_CLEAR: 'CARD_TRANSFER_POINT_SYSTEM_PROMPT_CLEAR',
  LIST_TRANSFER_POINT_SYSTEM_PROMPT: 'LIST_TRANSFER_POINT_SYSTEM_PROMPT',
  LIST_TRANSFER_POINT_SYSTEM_PROMPT_CLEAR: 'LIST_TRANSFER_POINT_SYSTEM_PROMPT_CLEAR',
  LIST_DELETE: 'LIST_DELETE',
  LIST_DELETE__SUCCESS: 'LIST_DELETE__SUCCESS',
  LIST_DELETE__FAILURE: 'LIST_DELETE__FAILURE',
  LIST_DELETE_HANDLE: 'LIST_DELETE_HANDLE',
  LIST_ARCHIVE: 'LIST_ARCHIVE',
  LIST_ARCHIVE__SUCCESS: 'LIST_ARCHIVE__SUCCESS',
  LIST_ARCHIVE__FAILURE: 'LIST_ARCHIVE__FAILURE',
  LIST_ARCHIVE_HANDLE: 'LIST_ARCHIVE_HANDLE',
  LIST_RESTORE: 'LIST_RESTORE',
  LIST_RESTORE__SUCCESS: 'LIST_RESTORE__SUCCESS',
  LIST_RESTORE__FAILURE: 'LIST_RESTORE__FAILURE',
  LIST_RESTORE_HANDLE: 'LIST_RESTORE_HANDLE',

  /* Cards */

  CARD_CREATE: 'CARD_CREATE',
  CARD_CREATE__SUCCESS: 'CARD_CREATE__SUCCESS',
  CARD_CREATE__FAILURE: 'CARD_CREATE__FAILURE',
  CARD_CREATE_HANDLE: 'CARD_CREATE_HANDLE',
  CARD_FETCH: 'CARD_FETCH',
  CARD_FETCH__SUCCESS: 'CARD_FETCH__SUCCESS',
  CARD_FETCH__FAILURE: 'CARD_FETCH__FAILURE',
  CARD_UPDATE: 'CARD_UPDATE',
  CARD_UPDATE__SUCCESS: 'CARD_UPDATE__SUCCESS',
  CARD_UPDATE__FAILURE: 'CARD_UPDATE__FAILURE',
  CARD_UPDATE_HANDLE: 'CARD_UPDATE_HANDLE',
  CARD_ARCHIVE: 'CARD_ARCHIVE',
  CARD_ARCHIVE__SUCCESS: 'CARD_ARCHIVE__SUCCESS',
  CARD_ARCHIVE__FAILURE: 'CARD_ARCHIVE__FAILURE',
  CARD_ARCHIVE_HANDLE: 'CARD_ARCHIVE_HANDLE',
  CARD_TRANSFER: 'CARD_TRANSFER',
  CARD_TRANSFER__SUCCESS: 'CARD_TRANSFER__SUCCESS',
  CARD_TRANSFER__FAILURE: 'CARD_TRANSFER__FAILURE',
  CARD_TRANSFER_STATUS_CLEAR: 'CARD_TRANSFER_STATUS_CLEAR',
  CARD_DELETE: 'CARD_DELETE',
  CARD_DELETE__SUCCESS: 'CARD_DELETE__SUCCESS',
  CARD_DELETE__FAILURE: 'CARD_DELETE__FAILURE',
  CARD_DELETE_HANDLE: 'CARD_DELETE_HANDLE',
  CARD_RESTORE: 'CARD_RESTORE',
  CARD_RESTORE__SUCCESS: 'CARD_RESTORE__SUCCESS',
  CARD_RESTORE__FAILURE: 'CARD_RESTORE__FAILURE',
  CARD_RESTORE_HANDLE: 'CARD_RESTORE_HANDLE',
  CARD_CLONE: 'CARD_CLONE',
  CARD_CLONE__SUCCESS: 'CARD_CLONE__SUCCESS',
  CARD_CLONE__FAILURE: 'CARD_CLONE__FAILURE',
  CARD_CLONE_HANDLE: 'CARD_CLONE_HANDLE',

  /* Tasks */

  TASK_CREATE: 'TASK_CREATE',
  TASK_CREATE__SUCCESS: 'TASK_CREATE__SUCCESS',
  TASK_CREATE__FAILURE: 'TASK_CREATE__FAILURE',
  TASK_CREATE_HANDLE: 'TASK_CREATE_HANDLE',
  TASK_UPDATE: 'TASK_UPDATE',
  TASK_UPDATE__SUCCESS: 'TASK_UPDATE__SUCCESS',
  TASK_UPDATE__FAILURE: 'TASK_UPDATE__FAILURE',
  TASK_UPDATE_HANDLE: 'TASK_UPDATE_HANDLE',
  TASK_DELETE: 'TASK_DELETE',
  TASK_DELETE__SUCCESS: 'TASK_DELETE__SUCCESS',
  TASK_DELETE__FAILURE: 'TASK_DELETE__FAILURE',
  TASK_DELETE_HANDLE: 'TASK_DELETE_HANDLE',

  /* Attachments */

  ATTACHMENT_CREATE: 'ATTACHMENT_CREATE',
  ATTACHMENT_CREATE__SUCCESS: 'ATTACHMENT_CREATE__SUCCESS',
  ATTACHMENT_CREATE__FAILURE: 'ATTACHMENT_CREATE__FAILURE',
  ATTACHMENT_CREATE_HANDLE: 'ATTACHMENT_CREATE_HANDLE',
  ATTACHMENT_UPDATE: 'ATTACHMENT_UPDATE',
  ATTACHMENT_UPDATE__SUCCESS: 'ATTACHMENT_UPDATE__SUCCESS',
  ATTACHMENT_UPDATE__FAILURE: 'ATTACHMENT_UPDATE__FAILURE',
  ATTACHMENT_UPDATE_HANDLE: 'ATTACHMENT_UPDATE_HANDLE',
  ATTACHMENT_DELETE: 'ATTACHMENT_DELETE',
  ATTACHMENT_DELETE__SUCCESS: 'ATTACHMENT_DELETE__SUCCESS',
  ATTACHMENT_DELETE__FAILURE: 'ATTACHMENT_DELETE__FAILURE',
  ATTACHMENT_DELETE_HANDLE: 'ATTACHMENT_DELETE_HANDLE',

  /* Activities */

  ACTIVITIES_FETCH: 'ACTIVITIES_FETCH',
  ACTIVITIES_FETCH__SUCCESS: 'ACTIVITIES_FETCH__SUCCESS',
  ACTIVITIES_FETCH__FAILURE: 'ACTIVITIES_FETCH__FAILURE',
  ACTIVITIES_DETAILS_TOGGLE: 'ACTIVITIES_DETAILS_TOGGLE',
  ACTIVITIES_DETAILS_TOGGLE__SUCCESS: 'ACTIVITIES_DETAILS_TOGGLE__SUCCESS',
  ACTIVITIES_DETAILS_TOGGLE__FAILURE: 'ACTIVITIES_DETAILS_TOGGLE__FAILURE',
  ACTIVITY_CREATE_HANDLE: 'ACTIVITY_CREATE_HANDLE',
  ACTIVITY_UPDATE_HANDLE: 'ACTIVITY_UPDATE_HANDLE',
  ACTIVITY_DELETE_HANDLE: 'ACTIVITY_DELETE_HANDLE',

  /* Comment activities */

  COMMENT_ACTIVITY_CREATE: 'COMMENT_ACTIVITY_CREATE',
  COMMENT_ACTIVITY_CREATE__SUCCESS: 'COMMENT_ACTIVITY_CREATE__SUCCESS',
  COMMENT_ACTIVITY_CREATE__FAILURE: 'COMMENT_ACTIVITY_CREATE__FAILURE',
  COMMENT_ACTIVITY_UPDATE: 'COMMENT_ACTIVITY_UPDATE',
  COMMENT_ACTIVITY_UPDATE__SUCCESS: 'COMMENT_ACTIVITY_UPDATE__SUCCESS',
  COMMENT_ACTIVITY_UPDATE__FAILURE: 'COMMENT_ACTIVITY_UPDATE__FAILURE',
  COMMENT_ACTIVITY_DELETE: 'COMMENT_ACTIVITY_DELETE',
  COMMENT_ACTIVITY_DELETE__SUCCESS: 'COMMENT_ACTIVITY_DELETE__SUCCESS',
  COMMENT_ACTIVITY_DELETE__FAILURE: 'COMMENT_ACTIVITY_DELETE__FAILURE',

  /* Notifications */

  NOTIFICATION_CREATE_HANDLE: 'NOTIFICATION_CREATE_HANDLE',
  NOTIFICATION_DELETE: 'NOTIFICATION_DELETE',
  NOTIFICATION_DELETE__SUCCESS: 'NOTIFICATION_DELETE__SUCCESS',
  NOTIFICATION_DELETE__FAILURE: 'NOTIFICATION_DELETE__FAILURE',
  NOTIFICATION_DELETE_HANDLE: 'NOTIFICATION_DELETE_HANDLE',

  /* Point systems */

  POINT_SYSTEM_UPDATE: 'POINT_SYSTEM_UPDATE',
  POINT_SYSTEM_UPDATE__SUCCESS: 'POINT_SYSTEM_UPDATE__SUCCESS',
  POINT_SYSTEM_UPDATE__FAILURE: 'POINT_SYSTEM_UPDATE__FAILURE',

  /* Employee plans */

  EMPLOYEE_PLANS_FETCH: 'EMPLOYEE_PLANS_FETCH',
  EMPLOYEE_PLANS_FETCH__SUCCESS: 'EMPLOYEE_PLANS_FETCH__SUCCESS',
  EMPLOYEE_PLANS_FETCH__FAILURE: 'EMPLOYEE_PLANS_FETCH__FAILURE',

  EMPLOYEE_PLAN_CREATE: 'EMPLOYEE_PLAN_CREATE',
  EMPLOYEE_PLAN_CREATE__SUCCESS: 'EMPLOYEE_PLAN_CREATE__SUCCESS',
  EMPLOYEE_PLAN_CREATE__FAILURE: 'EMPLOYEE_PLAN_CREATE__FAILURE',

  EMPLOYEE_PLAN_UPDATE: 'EMPLOYEE_PLAN_UPDATE',
  EMPLOYEE_PLAN_UPDATE__SUCCESS: 'EMPLOYEE_PLAN_UPDATE__SUCCESS',
  EMPLOYEE_PLAN_UPDATE__FAILURE: 'EMPLOYEE_PLAN_UPDATE__FAILURE',

  EMPLOYEE_PLAN_DELETE: 'EMPLOYEE_PLAN_DELETE',
  EMPLOYEE_PLAN_DELETE__SUCCESS: 'EMPLOYEE_PLAN_DELETE__SUCCESS',
  EMPLOYEE_PLAN_DELETE__FAILURE: 'EMPLOYEE_PLAN_DELETE__FAILURE',

  /* Content view plans */

  CONTENT_VIEW_PLANS_FETCH: 'CONTENT_VIEW_PLANS_FETCH',
  CONTENT_VIEW_PLANS_FETCH__SUCCESS: 'CONTENT_VIEW_PLANS_FETCH__SUCCESS',
  CONTENT_VIEW_PLANS_FETCH__FAILURE: 'CONTENT_VIEW_PLANS_FETCH__FAILURE',
  CONTENT_VIEW_PLAN_GET_OR_CREATE: 'CONTENT_VIEW_PLAN_GET_OR_CREATE',
  CONTENT_VIEW_PLAN_GET_OR_CREATE__SUCCESS: 'CONTENT_VIEW_PLAN_GET_OR_CREATE__SUCCESS',
  CONTENT_VIEW_PLAN_GET_OR_CREATE__FAILURE: 'CONTENT_VIEW_PLAN_GET_OR_CREATE__FAILURE',

  CONTENT_VIEW_PLAN_UPDATE: 'CONTENT_VIEW_PLAN_UPDATE',
  CONTENT_VIEW_PLAN_UPDATE__SUCCESS: 'CONTENT_VIEW_PLAN_UPDATE__SUCCESS',
  CONTENT_VIEW_PLAN_UPDATE__FAILURE: 'CONTENT_VIEW_PLAN_UPDATE__FAILURE',

  /* Damping coefficients */

  DAMPING_COEFFICIENT_GET_OR_CREATE: 'DAMPING_COEFFICIENT_GET_OR_CREATE',
  DAMPING_COEFFICIENT_GET_OR_CREATE__SUCCESS: 'DAMPING_COEFFICIENT_GET_OR_CREATE__SUCCESS',
  DAMPING_COEFFICIENT_GET_OR_CREATE__FAILURE: 'DAMPING_COEFFICIENT_GET_OR_CREATE__FAILURE',

  DAMPING_COEFFICIENTS_FETCH: 'DAMPING_COEFFICIENTS_FETCH',
  DAMPING_COEFFICIENTS_FETCH__SUCCESS: 'DAMPING_COEFFICIENTS_FETCH__SUCCESS',
  DAMPING_COEFFICIENTS_FETCH__FAILURE: 'DAMPING_COEFFICIENTS_FETCH__FAILURE',

  DAMPING_COEFFICIENT_CREATE: 'DAMPING_COEFFICIENT_CREATE',
  DAMPING_COEFFICIENT_CREATE__SUCCESS: 'DAMPING_COEFFICIENT_CREATE__SUCCESS',
  DAMPING_COEFFICIENT_CREATE__FAILURE: 'DAMPING_COEFFICIENT_CREATE__FAILURE',

  DAMPING_COEFFICIENT_UPDATE: 'DAMPING_COEFFICIENT_UPDATE',
  DAMPING_COEFFICIENT_UPDATE__SUCCESS: 'DAMPING_COEFFICIENT_UPDATE__SUCCESS',
  DAMPING_COEFFICIENT_UPDATE__FAILURE: 'DAMPING_COEFFICIENT_UPDATE__FAILURE',

  DAMPING_COEFFICIENT_DELETE: 'DAMPING_COEFFICIENT_DELETE',
  DAMPING_COEFFICIENT_DELETE__SUCCESS: 'DAMPING_COEFFICIENT_DELETE__SUCCESS',
  DAMPING_COEFFICIENT_DELETE__FAILURE: 'DAMPING_COEFFICIENT_DELETE__FAILURE',

  /* Monthly report */

  MONTHLY_REPORT_FETCH: 'MONTHLY_REPORT_FETCH',
  MONTHLY_REPORT_FETCH__SUCCESS: 'MONTHLY_REPORT_FETCH__SUCCESS',
  MONTHLY_REPORT_FETCH__FAILURE: 'MONTHLY_REPORT_FETCH__FAILURE',

  /* Content card defaults */

  CONTENT_CARD_DEFAULTS_FETCH: 'CONTENT_CARD_DEFAULTS_FETCH',
  CONTENT_CARD_DEFAULTS_FETCH__SUCCESS: 'CONTENT_CARD_DEFAULTS_FETCH__SUCCESS',
  CONTENT_CARD_DEFAULTS_FETCH__FAILURE: 'CONTENT_CARD_DEFAULTS_FETCH__FAILURE',

  CONTENT_CARD_DEFAULT_CREATE: 'CONTENT_CARD_DEFAULT_CREATE',
  CONTENT_CARD_DEFAULT_CREATE__SUCCESS: 'CONTENT_CARD_DEFAULT_CREATE__SUCCESS',
  CONTENT_CARD_DEFAULT_CREATE__FAILURE: 'CONTENT_CARD_DEFAULT_CREATE__FAILURE',

  CONTENT_CARD_DEFAULT_UPDATE: 'CONTENT_CARD_DEFAULT_UPDATE',
  CONTENT_CARD_DEFAULT_UPDATE__SUCCESS: 'CONTENT_CARD_DEFAULT_UPDATE__SUCCESS',
  CONTENT_CARD_DEFAULT_UPDATE__FAILURE: 'CONTENT_CARD_DEFAULT_UPDATE__FAILURE',

  CONTENT_CARD_DEFAULT_DELETE: 'CONTENT_CARD_DEFAULT_DELETE',
  CONTENT_CARD_DEFAULT_DELETE__SUCCESS: 'CONTENT_CARD_DEFAULT_DELETE__SUCCESS',
  CONTENT_CARD_DEFAULT_DELETE__FAILURE: 'CONTENT_CARD_DEFAULT_DELETE__FAILURE',

  /* Content types / templates */

  CONTENT_TYPE_TEMPLATES_FETCH: 'CONTENT_TYPE_TEMPLATES_FETCH',
  CONTENT_TYPE_TEMPLATES_FETCH__SUCCESS: 'CONTENT_TYPE_TEMPLATES_FETCH__SUCCESS',
  CONTENT_TYPE_TEMPLATES_FETCH__FAILURE: 'CONTENT_TYPE_TEMPLATES_FETCH__FAILURE',

  CONTENT_TYPE_TEMPLATE_CREATE: 'CONTENT_TYPE_TEMPLATE_CREATE',
  CONTENT_TYPE_TEMPLATE_CREATE__SUCCESS: 'CONTENT_TYPE_TEMPLATE_CREATE__SUCCESS',
  CONTENT_TYPE_TEMPLATE_CREATE__FAILURE: 'CONTENT_TYPE_TEMPLATE_CREATE__FAILURE',

  CONTENT_TYPE_TEMPLATE_UPDATE: 'CONTENT_TYPE_TEMPLATE_UPDATE',
  CONTENT_TYPE_TEMPLATE_UPDATE__SUCCESS: 'CONTENT_TYPE_TEMPLATE_UPDATE__SUCCESS',
  CONTENT_TYPE_TEMPLATE_UPDATE__FAILURE: 'CONTENT_TYPE_TEMPLATE_UPDATE__FAILURE',

  CONTENT_TYPE_TEMPLATE_DELETE: 'CONTENT_TYPE_TEMPLATE_DELETE',
  CONTENT_TYPE_TEMPLATE_DELETE__SUCCESS: 'CONTENT_TYPE_TEMPLATE_DELETE__SUCCESS',
  CONTENT_TYPE_TEMPLATE_DELETE__FAILURE: 'CONTENT_TYPE_TEMPLATE_DELETE__FAILURE',

  CONTENT_TYPE_TEMPLATE_ITEM_CREATE: 'CONTENT_TYPE_TEMPLATE_ITEM_CREATE',
  CONTENT_TYPE_TEMPLATE_ITEM_CREATE__SUCCESS: 'CONTENT_TYPE_TEMPLATE_ITEM_CREATE__SUCCESS',
  CONTENT_TYPE_TEMPLATE_ITEM_CREATE__FAILURE: 'CONTENT_TYPE_TEMPLATE_ITEM_CREATE__FAILURE',

  CONTENT_TYPE_TEMPLATE_ITEM_UPDATE: 'CONTENT_TYPE_TEMPLATE_ITEM_UPDATE',
  CONTENT_TYPE_TEMPLATE_ITEM_UPDATE__SUCCESS: 'CONTENT_TYPE_TEMPLATE_ITEM_UPDATE__SUCCESS',
  CONTENT_TYPE_TEMPLATE_ITEM_UPDATE__FAILURE: 'CONTENT_TYPE_TEMPLATE_ITEM_UPDATE__FAILURE',

  CONTENT_TYPE_TEMPLATE_ITEM_DELETE: 'CONTENT_TYPE_TEMPLATE_ITEM_DELETE',
  CONTENT_TYPE_TEMPLATE_ITEM_DELETE__SUCCESS: 'CONTENT_TYPE_TEMPLATE_ITEM_DELETE__SUCCESS',
  CONTENT_TYPE_TEMPLATE_ITEM_DELETE__FAILURE: 'CONTENT_TYPE_TEMPLATE_ITEM_DELETE__FAILURE',

  CONTENT_TYPES_FETCH: 'CONTENT_TYPES_FETCH',
  CONTENT_TYPES_FETCH__SUCCESS: 'CONTENT_TYPES_FETCH__SUCCESS',
  CONTENT_TYPES_FETCH__FAILURE: 'CONTENT_TYPES_FETCH__FAILURE',

  CONTENT_TYPE_CREATE: 'CONTENT_TYPE_CREATE',
  CONTENT_TYPE_CREATE__SUCCESS: 'CONTENT_TYPE_CREATE__SUCCESS',
  CONTENT_TYPE_CREATE__FAILURE: 'CONTENT_TYPE_CREATE__FAILURE',

  CONTENT_TYPE_UPDATE: 'CONTENT_TYPE_UPDATE',
  CONTENT_TYPE_UPDATE__SUCCESS: 'CONTENT_TYPE_UPDATE__SUCCESS',
  CONTENT_TYPE_UPDATE__FAILURE: 'CONTENT_TYPE_UPDATE__FAILURE',

  CONTENT_TYPE_DELETE: 'CONTENT_TYPE_DELETE',
  CONTENT_TYPE_DELETE__SUCCESS: 'CONTENT_TYPE_DELETE__SUCCESS',
  CONTENT_TYPE_DELETE__FAILURE: 'CONTENT_TYPE_DELETE__FAILURE',

  CONTENT_TYPE_TEMPLATE_APPLY: 'CONTENT_TYPE_TEMPLATE_APPLY',
  CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS: 'CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS',
  CONTENT_TYPE_TEMPLATE_APPLY__FAILURE: 'CONTENT_TYPE_TEMPLATE_APPLY__FAILURE',

  /* Card point data */

  CARD_POINT_DATA_FETCH: 'CARD_POINT_DATA_FETCH',
  CARD_POINT_DATA_FETCH__SUCCESS: 'CARD_POINT_DATA_FETCH__SUCCESS',
  CARD_POINT_DATA_FETCH__FAILURE: 'CARD_POINT_DATA_FETCH__FAILURE',

  CARD_POINT_DATA_UPSERT: 'CARD_POINT_DATA_UPSERT',
  CARD_POINT_DATA_UPSERT__SUCCESS: 'CARD_POINT_DATA_UPSERT__SUCCESS',
  CARD_POINT_DATA_UPSERT__FAILURE: 'CARD_POINT_DATA_UPSERT__FAILURE',

  CARD_POINT_DATA_COMPLETE: 'CARD_POINT_DATA_COMPLETE',
  CARD_POINT_DATA_COMPLETE__SUCCESS: 'CARD_POINT_DATA_COMPLETE__SUCCESS',
  CARD_POINT_DATA_COMPLETE__FAILURE: 'CARD_POINT_DATA_COMPLETE__FAILURE',

  CARD_POINT_DATA_UNCOMPLETE: 'CARD_POINT_DATA_UNCOMPLETE',
  CARD_POINT_DATA_UNCOMPLETE__SUCCESS: 'CARD_POINT_DATA_UNCOMPLETE__SUCCESS',
  CARD_POINT_DATA_UNCOMPLETE__FAILURE: 'CARD_POINT_DATA_UNCOMPLETE__FAILURE',

  /* List report data */

  LIST_REPORT_DATA_FETCH: 'LIST_REPORT_DATA_FETCH',
  LIST_REPORT_DATA_FETCH__SUCCESS: 'LIST_REPORT_DATA_FETCH__SUCCESS',
  LIST_REPORT_DATA_FETCH__FAILURE: 'LIST_REPORT_DATA_FETCH__FAILURE',
  LIST_REPORT_DATA_UPSERT: 'LIST_REPORT_DATA_UPSERT',
  LIST_REPORT_DATA_UPSERT__SUCCESS: 'LIST_REPORT_DATA_UPSERT__SUCCESS',
  LIST_REPORT_DATA_UPSERT__FAILURE: 'LIST_REPORT_DATA_UPSERT__FAILURE',
  LIST_REPORT_DATA_COMPLETE: 'LIST_REPORT_DATA_COMPLETE',
  LIST_REPORT_DATA_COMPLETE__SUCCESS: 'LIST_REPORT_DATA_COMPLETE__SUCCESS',
  LIST_REPORT_DATA_COMPLETE__FAILURE: 'LIST_REPORT_DATA_COMPLETE__FAILURE',
  LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE: 'LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE',
  LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__SUCCESS: 'LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__SUCCESS',
  LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__FAILURE: 'LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__FAILURE',

  CARD_POINT_ARCHIVED_DATA_CREATE__SUCCESS: 'CARD_POINT_ARCHIVED_DATA_CREATE__SUCCESS',
  CARD_POINT_ARCHIVED_DATA_DELETE__SUCCESS: 'CARD_POINT_ARCHIVED_DATA_DELETE__SUCCESS',

  /* Card point advanced data */

  CARD_POINT_ADVANCED_DATA_FETCH: 'CARD_POINT_ADVANCED_DATA_FETCH',
  CARD_POINT_ADVANCED_DATA_FETCH__SUCCESS: 'CARD_POINT_ADVANCED_DATA_FETCH__SUCCESS',
  CARD_POINT_ADVANCED_DATA_FETCH__FAILURE: 'CARD_POINT_ADVANCED_DATA_FETCH__FAILURE',

  CARD_POINT_ADVANCED_DATA_CREATE: 'CARD_POINT_ADVANCED_DATA_CREATE',
  CARD_POINT_ADVANCED_DATA_CREATE__SUCCESS: 'CARD_POINT_ADVANCED_DATA_CREATE__SUCCESS',
  CARD_POINT_ADVANCED_DATA_CREATE__FAILURE: 'CARD_POINT_ADVANCED_DATA_CREATE__FAILURE',

  CARD_POINT_ADVANCED_DATA_UPDATE: 'CARD_POINT_ADVANCED_DATA_UPDATE',
  CARD_POINT_ADVANCED_DATA_UPDATE__SUCCESS: 'CARD_POINT_ADVANCED_DATA_UPDATE__SUCCESS',
  CARD_POINT_ADVANCED_DATA_UPDATE__FAILURE: 'CARD_POINT_ADVANCED_DATA_UPDATE__FAILURE',

  CARD_POINT_ADVANCED_DATA_DELETE: 'CARD_POINT_ADVANCED_DATA_DELETE',
  CARD_POINT_ADVANCED_DATA_DELETE__SUCCESS: 'CARD_POINT_ADVANCED_DATA_DELETE__SUCCESS',
  CARD_POINT_ADVANCED_DATA_DELETE__FAILURE: 'CARD_POINT_ADVANCED_DATA_DELETE__FAILURE',
};
